var PrefPeriodScaleConstants = {
  Lin : 0,
  Log : 1,
  Auto : 2,
  NA : 3,
}
export default PrefPeriodScaleConstants;